export default __webpack_public_path__ + "static/media/36_desktop.a0111d2a.jpg";